let result;

export const msntPhotoThumbGallery = () => {
  if (result) return Promise.resolve(result);
  return import('./msnt-photo-thumb-gallery').then((module) => {
    result = module;
    return module;
  });
};